<template>
  <div id="app">
    <navbar/>
    <router-view/>
  </div>
</template>

<script>
import Navbar from './components/layout/Navbar'

export default {
  name: 'App',
  components: {
    'navbar': Navbar
  }
}
</script>

//global styling is defined here

<style>

  .section-background .global-question-card {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 1px 30px rgba(0,0,0,0.06);
    padding-top: 33px;
    padding-bottom: 33px;
    border-left: 10px solid;
    max-width: 980px;
    z-index: 1;
  }

  .section-background .global-question-card-padding {
    margin-top: 100px;
    margin-bottom: 50px;
    padding-left: 40px;
    padding-right: 40px;
    /* max-width: 980px; */
  }

  .global-answer-padding {
    padding-top: 42px;
  }

  .global-question-actions {
    text-align: right;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    color: #cccccc;
  }

  .global-question-icon {
      margin-left: 20px;
      color: #d1d0d0;
      font-size: 35px;
      cursor: pointer;
        height: 30px;
  }

  .ivu-icon {
    padding-left: 5px;
    /* padding-right: 2px; */

  }


  .global-background-footer {
    background-color: #f8f8f8;
  }

  /* .text-input .textarea {
    height: 100px;
    box-shadow: none;
    border-width: 1px;
    border-color: white;
    font-size: 24px;
    color: #4c4c4c;
    border-radius: 6px;
    margin-left: -10px;
    margin-top: -20px;
  } */
  .text-input .input{
    width:40%;
    box-shadow: none;
    border-width: 2px;
    height: 60px;
    border-color: #f2f2f2;
    font-size: 24px;
    color: #4c4c4c;
    border-radius: 6px;
  }

  .text-input .textarea {
    height: 100px;

    box-shadow: none;
    border-width: 2px;
    height: 60px;
    border-color: #f2f2f2;
    font-size: 24px;
    color: #4c4c4c;
    border-radius: 6px;
  }

  .text-input .textarea:hover {
    border-color: #cecece;
  }

  .text-input .textarea:focus {
    border-color: #cecece;
  }

  .comment-section .textarea {
    border-color: white;
    border-width: 0px;
    box-shadow: none;
  }

  .value-input .input {
    box-shadow: none;
    border-width: 2px;
    height: 60px;
    border-color: #f2f2f2;
    font-size: 35px;
    color: #4c4c4c;
    text-align: right;
    border-radius: 6px;
  }

  .value-input .input:hover {
    border-color: #cecece;
  }

  .value-input .input:focus {
    border-color: #cecece;
  }

  .scale-slider .ivu-slider-wrap {
    width: 100%;
    height: 10px;
    margin: 16px 0;
    background-color: #e8eaec;
    border-radius: 10px;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
  }

  .scale-slider .ivu-slider-stop {
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #ccc;
      transform: translateX(-50%);
  }

  .scale-slider .ivu-slider-bar {
    height: 10px;
    background: #5f5e5e;
    border-radius: 10px;
    position: absolute;
  }

  .scale-slider .ivu-slider-button {
    width: 22px;
    height: 22px;
    margin-top: -2px;
    border: 3px solid #5f5e5e;
    border-radius: 50%;
    background-color: #fff;
    transition: all .2s linear;
    outline: 0;
  }

  .scale-slider .ivu-slider-button:hover {
    border-color: #5f5e5e;
    transform: scale(1.5);
  }

  /* Checkboxes & radio buttons */
  .field .pretty .state label:before {
      border-color: #5f5e5e;
      border-width: 2px;
  }

  .field .pretty.p-default input:checked~.state label:after {
    background-color: #5f5e5e !important;
  }

  .field .pretty.p-bigger label {
    text-indent: 1.7em;
    padding-left: 10px;
  }

  /* Dropdown */
  .dropdown {
    position: absolute !important;
    /* box-shadow: 0 1px 30px rgba(0,0,0,0.06) !important; */
    border: none !important;
    /* min-height: 50px; */
  }

  .dropdown .dropdown-label-container .dropdown-label .text {
    font-family: inherit !important;
    color: #5f5e5e !important;
    font-size: 20px !important;
    padding-left: 5px !important;
  }

  .expanded .dropdown-label-container .dropdown-label .text {
    color: #dfdfdf !important;
  }

  .dropdown .angle-down {
    border-color: #515a6e !important;
  }

  .dropdown .options .option[data-v-48979943] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 4px 10px;
    height: 35px;
    font-family: inherit !important;
    font-size: 20px;
    color: #5f5e5e !important;
  }

  .dropdown .options .option:hover {
    /* color: black; */
    background: #eeeeee !important;
    /* -webkit-transition: all 0.7s;
    transition: all 0.7s; */
}

  .expanded {
    box-shadow: 0 1px 30px rgba(0,0,0,0.1) !important;
    max-height: 500px;
  }

  .expand {
    overflow-y: scroll !important;
  }

  .dropdown-label {
    height: 45px !important;
  }

  .intro-message {
    max-width: 860px;
  }

  .vdp-datepicker input {
    background-color: #f2f2f2;
    border: 2px solid #f2f2f2 !important;
    width: 300px;
    border-radius: 7px !important;
    cursor: pointer;
  }

  .vdp-datepicker input:focus {
    outline: none;
  }

  .vdp-datepicker__calendar {
    margin-top: -57px !important;
    background: #fff !important;
    border: none !important;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
    border-radius: 10px !important;
    padding: 10px;
}

.vdp-datepicker__calendar .cell.selected {
    background: #ececec !important;
    border: 2px solid #ececec !important;

    border-radius: 10px;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
    border: 2px solid #c0c0c0 !important;

    border-radius: 10px;
}

.vdp-datepicker__calendar .cell.selected:hover {
    background: #ececec !important;

    border-radius: 10px;

}

.long-value {
  margin-top: -39px;
  margin-left: 45px;
  padding-bottom: 5px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/App.vue